"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbSessionStorage = void 0;
class MbSessionStorage {
    constructor(storage) {
        this.getSavedSessionData = () => {
            const username = this.storage.getItem('username');
            const savedExpiresIn = this.storage.getItem('expiresIn');
            const expiresIn = savedExpiresIn ? Number(savedExpiresIn) : 0;
            const savedSessionExpiresAt = this.storage.getItem('sessionExpiresAt');
            const sessionExpiresAt = savedSessionExpiresAt?.trim() ? new Date(savedSessionExpiresAt) : null;
            const accessToken = this.storage.getItem('accessToken');
            const refreshToken = this.storage.getItem('refreshToken');
            const savedTimeOutStamp = this.storage.getItem('timeOutStamp');
            const timeOutStamp = savedTimeOutStamp ? Number(savedTimeOutStamp) : 0;
            const customerSessionId = this.storage.getItem('customerSessionId');
            return username && accessToken && refreshToken
                ? {
                    username,
                    expiresIn,
                    sessionExpiresAt,
                    accessToken,
                    refreshToken,
                    timeOutStamp,
                    customerSessionId,
                }
                : null;
        };
        this.storage = storage;
    }
    checkSecurityData(data) {
        return data?.accessToken && data?.refreshToken && data?.username;
    }
    checkExpiresData(data) {
        return data?.expiresIn && data?.timeOutStamp;
    }
    checkSecurityAndExpiration(data) {
        return Boolean(this.checkSecurityData(data) && this.checkExpiresData(data));
    }
    saveSessionData(newData) {
        if (this.checkSecurityAndExpiration(newData)) {
            this.storage.setItem('username', newData.username);
            this.storage.setItem('expiresIn', newData.expiresIn?.toString() || '');
            this.storage.setItem('sessionExpiresAt', newData.sessionExpiresAt?.toISOString() || '');
            this.storage.setItem('accessToken', newData.accessToken);
            this.storage.setItem('refreshToken', newData.refreshToken);
            this.storage.setItem('timeOutStamp', newData.timeOutStamp?.toString() || '');
            this.storage.setItem('customerSessionId', newData.customerSessionId || '');
        }
    }
    removeSavedSessionData() {
        this.storage.removeItem('username');
        this.storage.removeItem('expiresIn');
        this.storage.removeItem('sessionExpiresAt');
        this.storage.removeItem('accessToken');
        this.storage.removeItem('refreshToken');
        this.storage.removeItem('timeOutStamp');
        this.storage.removeItem('customerSessionId');
    }
}
exports.MbSessionStorage = MbSessionStorage;
//# sourceMappingURL=sessionStorage.js.map